import { render, staticRenderFns } from "./SimuVillage.vue?vue&type=template&id=5c6862ec&scoped=true"
import script from "./SimuVillage.vue?vue&type=script&lang=js"
export * from "./SimuVillage.vue?vue&type=script&lang=js"
import style0 from "./SimuVillage.vue?vue&type=style&index=0&id=5c6862ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6862ec",
  null
  
)

export default component.exports